import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Home, FolderKanban, MessageSquare, Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AdminGuard from "@/components/admin/AdminGuard";
import ProgettiPanel from "@/components/admin/ProgettiPanel";
import TestimonianzePanel from "@/components/admin/TestimonianzePanel";
import SubmissionsPanel from "@/components/admin/SubmissionsPanel";
import { logout } from "@/lib/api";

export default function AdminDashboard() {
  return (
    <AdminGuard>{(user) => <Dashboard user={user} />}</AdminGuard>
  );
}

function Dashboard({ user }) {
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      await logout();
    } catch {
      // ignora — sessione probabilmente già scaduta
    }
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {/* Top bar */}
      <header className="bg-white border-b border-[#E2E8F0] sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <h1 className="text-lg font-bold text-[#0B1E36]">
              Finestre e Colore — Admin
            </h1>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden sm:inline text-sm text-[#64748B]">
              {user?.email}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate("/")}
              data-testid="admin-view-site"
            >
              <Home className="w-4 h-4 mr-1" />
              <span className="hidden sm:inline">Vedi sito</span>
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={handleLogout}
              disabled={loggingOut}
              data-testid="admin-logout"
            >
              <LogOut className="w-4 h-4 mr-1" />
              <span className="hidden sm:inline">Esci</span>
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Tabs defaultValue="richieste" className="w-full">
          <TabsList className="mb-6">
            <TabsTrigger value="richieste" data-testid="tab-richieste">
              <Inbox className="w-4 h-4 mr-2" />
              Richieste
            </TabsTrigger>
            <TabsTrigger value="progetti" data-testid="tab-progetti">
              <FolderKanban className="w-4 h-4 mr-2" />
              Progetti
            </TabsTrigger>
            <TabsTrigger value="testimonianze" data-testid="tab-testimonianze">
              <MessageSquare className="w-4 h-4 mr-2" />
              Testimonianze
            </TabsTrigger>
          </TabsList>

          <TabsContent value="richieste">
            <SubmissionsPanel />
          </TabsContent>

          <TabsContent value="progetti">
            <ProgettiPanel />
          </TabsContent>

          <TabsContent value="testimonianze">
            <TestimonianzePanel />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
